module.exports = __webpack_public_path__ + "img/Endress + Hauser.a68ae7fd.png";